import {setCustomerOfferCoefficient} from "@project/sdk/sales";
import {SetCustomerOfferCoefficientResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";
import {setCustomerOfferCoefficientFormSchema} from "./set-customer-offer-coefficient.schema";
import type {SetCustomerOfferCoefficientFormPayload} from "./set-customer-offer-coefficient.schema";

export function setCustomerOfferCoefficientMutationOptions(id: string, chapterId: string) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.setCustomerOfferCoefficient,
    retry: false,
    mutationFn: async (payload: SetCustomerOfferCoefficientFormPayload) =>
      SetCustomerOfferCoefficientResponse.parse(
        await setCustomerOfferCoefficient(
          id,
          chapterId,
          setCustomerOfferCoefficientFormSchema.parse(payload),
        ),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
